import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import cls from "./category.module.scss";
import Script from "next/script";
import ProductCard from "../Products/ProductCard";
import { IProduct, TranslationsType } from "../../../types/homePageTypes";
import { ICurrencies } from "../Wrappers/MainLayout";
import { useRouter } from "next/router";
import { schemaCategoryPage } from "../../schemaorg";

interface IProps {
    productsList: Array<IProduct>;
    dbName: string;
    whichOneRender: {
        firstDivClassName: string;
        firstDivParams: { "data-layout": string } | {};
        secondDivClassName: string;
        showEmptyFiltersSection: boolean;
        showElement: "List" | "Empty"
    };
    selectedRate: ICurrencies;
    selectedLocale: string;
    translationsData: TranslationsType;
    backOrderValue: string;
    isMobile: boolean
}

const ProductsView: FC<IProps> = (
    {
        productsList: productsListData,
        dbName,
        selectedRate: {
            symbol: selectedCurrSymbol = "",
            exchange_rate: {rate: selectedCurrRate = "1"} = {},
            code: selectedCurrCode = ""
        } = {},
        selectedLocale,
        translationsData,
        backOrderValue,
        whichOneRender: {
            firstDivClassName,
            firstDivParams,
            secondDivClassName,
            showEmptyFiltersSection,
            showElement
        },
        isMobile
    }
) => {
    const router = useRouter();
    const schema = schemaCategoryPage(productsListData, dbName);
    const ref = useRef<HTMLDivElement>(null)
    const [originalProducts, setOriginalProducts] = useState<boolean>(false);
    useEffect(() => {
        const handleScroll = () => {
            if (ref && ref.current) {
                setOriginalProducts(window.scrollY >= 80)
            }
        }
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll)
        }

        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])
    const contentHandler = {
        List: (isMobile && !originalProducts
            ? productsListData.filter((_, indexFil) => indexFil < 4)
            : productsListData).map((product: IProduct, index: number) => (
            <div key={index} className={cls["products-list__item"]} ref={!originalProducts ? ref : null}>
                <ProductCard
                    product={product}
                    dbName={dbName}
                    translationsData={translationsData}
                    backOrderValue={backOrderValue}
                    selectedCurrItems={{selectedCurrCode, selectedCurrRate, selectedCurrSymbol}}
                    selectedLocale={selectedLocale}
                    priority={index < 2}
                    loading={index < 2 ? "eager" : "lazy"}
                />
            </div>
        )),
        Empty: translationsData?.NoProductsYet
    }

    return (
        <Fragment>
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
            />
            <div className={cls["products-view"]}>
                <div className={cls["products-view__loader"]}/>
                <div className={cls[firstDivClassName]} {...firstDivParams}>
                    <div className={cls[secondDivClassName]}>{contentHandler[showElement]}</div>
                    {showEmptyFiltersSection && Object.keys(router.query).includes("filter") ? (
                        <button className="btn btn-orange btn-sm" onClick={async () => {
                            await router.push(`/catalog/${router.query.slug}`);
                        }}>
                            {translationsData?.Reset}
                        </button>
                    ) : <Fragment />}
                </div>
            </div>
        </Fragment>
    )
}

export default ProductsView
